// Проверить, является ли номер ЮMoney кошелька валидным
// number: string
export default function isUMoneyWalletNumberValid(number) {
  return number.length >= 11;
}
